import api from '@/core/api'
import { handleError } from '@/helpers/handleError'
import type { ApiErrorResponse, ApiResponse } from '@/types/apiResponse'

export async function getOrderById(orderId: number): Promise<ApiResponse> {
  try {
    const { data } = await api.get(`/wp-json/wc/v3/orders/${orderId}`)
    return {
      success: true,
      data
    }
  } catch (error: any) {
    handleError(error)
    return {
      success: false,
      error: error as ApiErrorResponse
    }
  }
}
